import React, { useState } from "react";
import { useIntl } from "react-intl";
import { Row, Col } from "antd";

import TableHeader from "../../components/app/generic/tableHeader";
import ResultDisplay from "../../components/calculator/resultDisplay";
import CalculationForm from "../../components/calculator/calculationForm";

function Calculator() {
  const intl = useIntl();
  const [nonEu, setNonEu] = useState();
  const [result, setResult] = useState();
  const [formData, setFormData] = useState();
  const [loading, setLoading] = useState(true);
  const [isSlovakia, setIsSlovakia] = useState();
  return (
    <Row type="flex" justify="center" align="middle">
      <Col xxl={22} lg={24} sm={24}>
        <Row>
          <Col>
            <TableHeader
              title={intl.formatMessage({
                id: "calculator",
                defaultMessage: "Kalkulátor ceny",
              })}
            />
          </Col>
          {/* <Alert
            showIcon
            closable
            type="warning"
            message={intl.formatMessage({
              id: "messages.warning",
              defaultMessage: "Upozornění",
            })}
            description={intl.formatMessage({
              id: "calculator.warning",
              defaultMessage:
                "Cena nezahrnuje Krizový palivový příplatek. Pro více informací prosím kontaktuje Zákaznické centrum DHL Freight CZ na DHLFreight.cz@dhl.com nebo +420 239 018 222.",
            })}
          /> */}
          <Col>
            <Row gutter={25} type="flex" justify="center" align="middle">
              <Col sm={24} md={15}>
                <CalculationForm
                  nonEu={nonEu}
                  onSetNonEu={setNonEu}
                  onSetResult={setResult}
                  onSetLoading={setLoading}
                  onSetFormData={setFormData}
                  onSetIsSlovakia={setIsSlovakia}
                />
              </Col>
              {!loading && (
                <Col sm={24} md={9}>
                  <ResultDisplay
                    nonEu={nonEu}
                    result={result}
                    formData={formData}
                    isSlovakia={isSlovakia}
                  />
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default Calculator;
